import { ReactComponent as CheckedCircle } from '@public/icons/checked-circle.svg';
import Icon from '../atoms/Icon';

const IconCheckedCircle = (props) => <Icon as={CheckedCircle} {...props} />;

IconCheckedCircle.propTypes = Icon.propTypes;

export default IconCheckedCircle;
